// import Vue from 'vue';
// import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: sessionStorage.token,
    isMobile: IsPC(),
    roleId:sessionStorage.getItem('roleId')
  },
  mutations: {
    // 用户登录成功，存储 token 并设置 header 头
    changeToken(state, token) {
      state.token = token;
    },
    clearAll(state) {
      state.token = '';
    },
    changeIsMobile(state,isMobile){
      state.isMobile = isMobile;
    },
    changeId(state,id){
      state.roleId = id;
    }
  },
  actions: {}
})
// window.onresize = function(){
//   document.getElementById('body').remove();
//   location.reload();
// }
// console.log(store);
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js